export const normalizePrintNote = (note) => String(note ?? '')
  .split(/\r?\n/)
  .map((line) => line.trim())
  .filter(Boolean)
  .join(' / ');

export const appendPrintNote = (line, ...notes) => {
  const normalizedNotes = notes
    .map(normalizePrintNote)
    .filter(Boolean);

  if (normalizedNotes.length === 0) return line;
  return `${line}\r\n   NOTA: ${normalizedNotes.join(' / ')}`;
};
